const tokenItem = 'bp-pool-token';
const whoamiIdItem = 'bp-pool-whoami-id';

export const cache = {
  token: token => localStorage.setItem(tokenItem, token),
  whoamiId: wId => localStorage.setItem(whoamiIdItem, wId),
};

export const getCached = {
  token: () => localStorage.getItem(tokenItem),
  whoamiId: () => localStorage.getItem(whoamiIdItem),
};

export const clearCache = () => localStorage.clear();
